export function MetricCard({ label, value, sub, accent = "default", testId }) {
  const accentClass = {
    default: "text-zinc-950",
    danger: "text-[#FF3B30]",
    warn: "text-[#B58900]",
    info: "text-[#002FA7]",
    success: "text-emerald-600",
  }[accent];

  return (
    <div
      data-testid={testId}
      className="border border-zinc-200 bg-white p-6 flex flex-col gap-2 hover:border-zinc-300 transition-colors"
    >
      <div className="overline">{label}</div>
      <div className={`font-mono-num text-3xl font-semibold ${accentClass}`}>
        {value}
      </div>
      {sub && <div className="text-xs text-zinc-500">{sub}</div>}
    </div>
  );
}

export function PriorityBadge({ priority, testId }) {
  const p = (priority || "").toLowerCase();
  if (p === "high")
    return (
      <span
        data-testid={testId}
        className="px-2 py-0.5 text-[10px] uppercase tracking-wider font-bold bg-[#FF3B30] text-white"
      >
        High
      </span>
    );
  if (p === "medium")
    return (
      <span
        data-testid={testId}
        className="px-2 py-0.5 text-[10px] uppercase tracking-wider font-bold bg-[#FFCC00] text-zinc-900"
      >
        Medium
      </span>
    );
  return (
    <span
      data-testid={testId}
      className="px-2 py-0.5 text-[10px] uppercase tracking-wider font-bold bg-zinc-200 text-zinc-700"
    >
      {p || "low"}
    </span>
  );
}

export function KeywordPill({ children, testId }) {
  return (
    <span
      data-testid={testId}
      className="px-2 py-1 bg-zinc-100 text-zinc-700 text-xs border border-zinc-200 font-mono-num"
    >
      {children}
    </span>
  );
}

export function PrimaryButton({ children, className = "", ...rest }) {
  return (
    <button
      {...rest}
      className={`bg-zinc-950 text-white px-4 py-2 text-sm font-medium hover:bg-zinc-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${className}`}
    >
      {children}
    </button>
  );
}

export function SecondaryButton({ children, className = "", ...rest }) {
  return (
    <button
      {...rest}
      className={`bg-white text-zinc-900 border border-zinc-200 px-4 py-2 text-sm font-medium hover:bg-zinc-50 disabled:opacity-50 transition-colors ${className}`}
    >
      {children}
    </button>
  );
}

export function Input({ className = "", ...rest }) {
  return (
    <input
      {...rest}
      className={`border border-zinc-200 bg-white text-zinc-950 px-3 py-2 text-sm focus:outline-none focus:border-zinc-950 focus:ring-1 focus:ring-zinc-950 placeholder:text-zinc-400 ${className}`}
    />
  );
}

export function Select({ className = "", children, ...rest }) {
  return (
    <select
      {...rest}
      className={`border border-zinc-200 bg-white text-zinc-950 px-3 py-2 text-sm focus:outline-none focus:border-zinc-950 ${className}`}
    >
      {children}
    </select>
  );
}

export function Toggle({ checked, onChange, label, testId }) {
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer select-none">
      <span
        role="switch"
        aria-checked={checked}
        data-testid={testId}
        onClick={() => onChange(!checked)}
        className={`w-9 h-5 inline-flex items-center transition-colors border ${
          checked ? "bg-zinc-950 border-zinc-950" : "bg-zinc-100 border-zinc-300"
        }`}
      >
        <span
          className={`w-4 h-4 bg-white transition-transform ${
            checked ? "translate-x-4" : "translate-x-0.5"
          }`}
        />
      </span>
      {label && <span className="text-sm text-zinc-700">{label}</span>}
    </label>
  );
}
